import React, { useState } from 'react';
import { Button, Modal } from 'antd';

const SkipButton = ({ skipEvent }) => {
   

  return (
    <div style={{ textAlign: 'center', margin: '20px' }}>
      <div style={{ margin: '20px' }}>
        <Button type="primary" onClick={skipEvent} style={{ width: '100%' }}>
          SKIP!
        </Button>
      </div>
      
    </div>
  );
};

export { SkipButton };
